<template>
  <div class="services">
      <Service
        v-for="(service, i) in services"
        v-bind:key="service._id"
        v-bind:service="service"
        v-bind:serviceIndex="i"
        v-bind:instanceIndex="instanceIndex"
        v-bind:instanceUrl="instanceUrl"
      />
  </div>
</template>


<script>
import Service from '@/components/Service.vue'
export default {
  props: ['services', 'instanceIndex', 'instanceUrl'],
  components: {
    Service
  }
}
</script>

<style>
  .services {
    display: flex;
    justify-content: center;
  }
</style>